import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { catchError, firstValueFrom, throwError } from "rxjs";
import { MeetingBulkRequest } from "@app/services/api/v1/meeting/dto/meeting-bulk-request";
import { MeetingBulkResponse } from "@app/services/api/v1/meeting/dto/meeting-bulk-response";
import { ResourceAvailabilityRequest } from "@app/services/api/v1/meeting/dto/resource-availability-request";
import { ResourceAvailabilityResponse } from "@app/services/api/v1/meeting/dto/resource-availability-response";
import { MeetingInstanceUpdateRequest } from "@app/services/api/v1/meeting/dto/meeting-instance-update-request";
import { MeetingInstanceUpdateResponse } from "@app/services/api/v1/meeting/dto/meeting-instance-update-response";

@Injectable({
  providedIn: "root"
})
export class MeetingService {
  private http = inject(HttpClient);
  private clientConfigService = inject(ClientConfigService);

  public async bulk(
    meetingBulkRequest: MeetingBulkRequest
  ): Promise<MeetingBulkResponse> {
    const config = this.clientConfigService.config;
    return firstValueFrom(
      this.http
        .post<MeetingBulkResponse>(
          `${config.serviceUrl}/api/v1/meeting/bulk`,
          meetingBulkRequest,
          { withCredentials: true }
        )
        .pipe(
          catchError((error) => {
            console.error("Bulk meeting creation failed:", error);
            return throwError(() => error);
          })
        )
    );
  }

  public async checkAvailability(
    request: ResourceAvailabilityRequest
  ): Promise<ResourceAvailabilityResponse> {
    const config = this.clientConfigService.config;
    return firstValueFrom(
      this.http
        .post<ResourceAvailabilityResponse>(
          `${config.serviceUrl}/api/v1/meeting/checkAvailability`,
          request,
          { withCredentials: true }
        )
        .pipe(
          catchError((error) => {
            console.error("Check availability failed:", error);
            return throwError(() => error);
          })
        )
    );
  }

  public async updateInstance(
    request: MeetingInstanceUpdateRequest
  ): Promise<MeetingInstanceUpdateResponse> {
    const config = this.clientConfigService.config;
    return firstValueFrom(
      this.http
        .post<MeetingInstanceUpdateResponse>(
          `${config.serviceUrl}/api/v1/meeting/updateInstance`,
          request,
          { withCredentials: true }
        )
        .pipe(
          catchError((error) => {
            console.error("Update meeting instance failed:", error);
            return throwError(() => error);
          })
        )
    );
  }
}
